import { Modal } from 'bootstrap';
import BaseComponent from '../../../../../common/js/BaseComponent';
import Helper from '../../../../../common/utils/helper';

export default class Layout extends BaseComponent {
    loginModalElement: HTMLElement | null;

    registerModalElement: HTMLElement | null;

    loginModalInstance: Modal | null;

    registerModalInstance: Modal | null;

    recaptchaField: any;

    private getForgetPasswordForm(element: HTMLLinkElement): void {
        this.updateModalLoginCol(element);
    }

    private getRegisterForm(element: HTMLButtonElement): void {
        this.initRegisterModal(element, () => {
            this.initRegisterEvent();
        });
    }

    static getSelectorForgetPassword(): string {
        return '.forgot-password';
    }

    static getSelectorRegister(): string {
        return '.register-request';
    }

    static getSelectorLogin(): string {
        return '.login-request';
    }

    init(): any {
        this.getLoginModal();
    }

    private sendAuthGtm(element: HTMLElement | null) {
        // recupération des données JSON si présentes, et envoi au datalayer.
        const gtm = element?.getAttribute('data-gtm') ?? null;
        const jsonData = gtm ? JSON.parse(window.atob(gtm)) : null;
        if (jsonData) {
            // @ts-ignore
            HegydGtm?.pushToDatalayer(jsonData);
        }
    }

    private getLoginModal() {
        this.view.addEventListener('click', (e) => {
            e.preventDefault();
            const url = new URL(`${window.location.origin}/connexion`);
            const urlParams = new URLSearchParams();
            if (this.view.hasAttribute('data-fav')) {
                urlParams.set('fav', 'true');
            }

            url.search = urlParams.toString();

            fetch(url, {
                method: 'GET',
                headers: Helper.createFetchHeader(),
            })
                .then((response) => Promise.all([response, response.text()]))
                .then(([, data]) => {
                    this.createLoginModal(data);
                });
        });
    }

    private createLoginModal(data: string) {
        // On inject ma modal dans mon DOM
        document.body.insertAdjacentHTML('beforeend', data);

        // On va récupérer la modal précédement injecté
        this.loginModalElement = document.getElementById('modalAccount');
        // On vérifie que la modal existe bien
        if (this.loginModalElement) {
            // On ajoute les evts show/hide etc
            this.onLoginModalShow();
            this.onLoginModalHide();
            // On affiche ma modale
            this.loginModalInstance = window.bootstrap.Modal.getOrCreateInstance(this.loginModalElement);
            this.loginModalInstance.show();
        }
    }

    private initModalEvents() {
        // Click sur le boutton de mdp oublié
        const forgetPassword = document.querySelector(Layout.getSelectorForgetPassword());
        if (forgetPassword) {
            forgetPassword.addEventListener('click', (e) => {
                e.preventDefault();
                this.getForgetPasswordForm(e.target as HTMLLinkElement);
            });
        }
        // Click sur le bouton de d'inscription
        const register = document.querySelector(Layout.getSelectorRegister());
        if (register) {
            register.addEventListener('click', (e) => {
                e.preventDefault();
                this.getRegisterModal(e.target as HTMLButtonElement);
            });
        }
        // Click sur le bouton de login
        const login = document.querySelector(Layout.getSelectorLogin());
        if (login) {
            login.addEventListener('click', (e) => {
                e.preventDefault();
                this.submitLoginForm();
            });
        }
    }

    private submitLoginForm() {
        const loginForm = document.getElementById('loginform') as HTMLFormElement;
        if (loginForm) {
            this.forceSubmitForm(loginForm);
        }
    }

    private async forceSubmitForm(loginForm: HTMLFormElement) {
        if (!loginForm.checkValidity()) {
            loginForm.reportValidity();
            return;
        }
        const formData = new FormData(loginForm);
        try {
            const response = await fetch(loginForm.action, {
                method: 'POST',
                body: formData,
                // @ts-ignore
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
                },
            });

            //  Si la réponse est OK, rediriger vers le tableau de bord
            if (response.ok) {
                this.sendAuthGtm(this.loginModalElement);
                window.location.href = '/';
            } else {
                const errorLoginElement = document.getElementById('error-login');
                if (errorLoginElement) {
                    errorLoginElement.style.display = 'inline-block';
                }
            }
        } catch (error) {
            // Si une exception est levée, afficher le message d'erreur
        }
    }

    private onLoginModalShow() {
        if (this.loginModalElement != null) {
            this.loginModalElement.addEventListener('show.bs.modal', () => {
                this.initModalEvents();
            });
        }
    }

    private onLoginModalHide() {
        if (this.loginModalElement != null) {
            this.loginModalElement.addEventListener('hidden.bs.modal', () => {
                this.loginModalElement?.remove();
                this.loginModalInstance = null;
            });
        }
    }

    private getRegisterModal(element: HTMLButtonElement) {
        return fetch(element.getAttribute('data-modal-url') ?? '/', {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                this.loginModalInstance?.hide();
                this.createRegisterModal(data);
                this.getRegisterForm(element);
            });
    }

    private createRegisterModal(data: string) {
        document.body.insertAdjacentHTML('beforeend', data);
        // On va récupérer la modal précédement injecté
        this.registerModalElement = document.getElementById('modalRegister');
        // On vérifie que la modal existe bien
        if (this.registerModalElement) {
            // On ajoute les evts show/hide etc
            this.onRegisterModalHide();
            // On affiche ma modale
            this.registerModalInstance = window.bootstrap.Modal.getOrCreateInstance(this.registerModalElement);
        }
    }

    private onRegisterModalHide() {
        if (this.registerModalElement != null) {
            this.registerModalElement.addEventListener('hidden.bs.modal', () => {
                this.registerModalElement?.remove();
                this.registerModalInstance = null;
            });
        }
    }

    private updateModalLoginCol(element: HTMLLinkElement): void {
        fetch(element.getAttribute('href') ?? '/', {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                const modalContent = this.loginModalElement?.querySelector('.login-col');
                if (modalContent) {
                    modalContent.innerHTML = data;
                }
            });
    }

    private initRegisterEvent(): void {
        // Chargement des composants dans le formulaire pour forcer le chargement ZipCitySelector
        (window as any).Kernel.mountComponents(document.querySelector('#loginform'));
        if (document.querySelector('[name="g-recaptcha-response"]') != null) {
            this.initRecaptcha('register_id', 'register_action');
        }
        const flexSwitchCheckDefault: HTMLInputElement | null | undefined = this.registerModalElement?.querySelector('#flexSwitchCheckDefault');
        const proFields = this.registerModalElement?.querySelectorAll('.profield');

        flexSwitchCheckDefault?.addEventListener('click', () => {
            if (flexSwitchCheckDefault.checked) {
                proFields?.forEach((proField) => {
                    proField.classList.remove('d-none');
                });
            } else {
                proFields?.forEach((proField) => {
                    proField.classList.add('d-none');
                });
            }
        });
    }

    private initRegisterModal(element: HTMLButtonElement, loadedCallback?: () => any) {
        (window as any).HegydCore.initRemoteModal('#modalRegister', element.getAttribute('data-form-url') ?? '/', loadedCallback, () => {
            this.sendAuthGtm(this.registerModalElement);
            setTimeout(() => {
                (window as any).toastr.success(this.registerModalElement?.getAttribute('data-message-user-updated-success'));
                window.location.reload();
            }, 300);
        }, (data: any) => {
            const response = JSON.parse(data.responseText);

            if (response['g-recaptcha-response'] !== undefined) {
                (window as any).toastr.error(response['g-recaptcha-response']);
            } else if (typeof response === 'string') {
                (window as any).toastr.error(response);
            } else {
                (window as any).toastr.error('Une erreur est survenue !');
            }
            this.refreshRecaptcha('register_action');
            setTimeout(() => {
                (window as any).toastr.error(this.registerModalElement?.getAttribute('data-message-user-updated-error'));
            }, 10);
        });
    }

    private initRecaptcha(field: string, action: string) {
        const self = this;
        this.recaptchaField = grecaptcha.render(field, {
            sitekey: (document.querySelector('input[name="recaptcha_key"]') as HTMLInputElement)?.value?.toString() ?? '',
            size: 'invisible',
            hl: 'fr',
            // 'callback': function() {}
        });
        grecaptcha.ready(() => {
            grecaptcha.execute(self.recaptchaField, {
                action,
            }).then((token: string) => {
                document.querySelector('[name="g-recaptcha-response"]')?.setAttribute('value', token);
            });
        });
    }

    private refreshRecaptcha(action: any) {
        const self = this;
        grecaptcha.ready(() => {
            grecaptcha.execute(self.recaptchaField, {
                action,
            }).then((token: string) => {
                document.querySelector('[name="g-recaptcha-response"]')?.setAttribute('value', token);
            });
        });
    }
}
